import { usePermission } from '@fs/zion-permissions'
import { PORTAL_CONTEXT, TOOLS_PERMISSION } from '../constants'

// The portal's one permission check, shared by the root route gate (App) and the header nav (PortalChrome).
export default function useToolsPermission() {
  const [hasToolsPermission, status, error] = usePermission(TOOLS_PERMISSION, PORTAL_CONTEXT)
  return {
    hasToolsPermission: Boolean(hasToolsPermission),
    isLoading: status === 'loading',
    isError: status === 'error',
    error,
  }
}
